module.exports = __webpack_public_path__ + "img/GOLOS-alt.6aff72bf.svg";